import React from 'react'
import InsightsSVG from 'src/images/insights_icon.svg';
import BuildWithSVG from 'src/images/build_with_us_icon.svg';
import ModelsSVG from 'src/images/models_icon.svg';
import AnomalySVG from 'src/images/anomaly.svg';
import UnAssignedSVG from 'src/images/unassigned.svg';
import SampleSVG from 'src/images/sample.svg';
import ChatSVG from 'src/images/chat.svg';
import { useNavigate } from 'react-router-dom';
import { RouteConstants } from 'src/constants/routeConstants';
import { Button } from '@scuf/common';


type Tab = {
  id: number;
  icon: string;
  text: string;
  description: string;
  button_text: string;
  onClick: () => void;
};

type TabConfig = {
  [role: string]: Tab[];
};

type TabListProps = {
  role: string;
};

const SmallCard = ({ icon, text, description, button_text, onClick = () => false }: any) => {
  return (
    <>
      <div className={`small-card-container  ${text} `} onClick={onClick}>
      <div className='small-card-container-upper'>
          <div className="icon1">
            <img className="img1" src={icon} alt={text} />
          </div>
          <div className='card-text'>{text}</div>
        </div>
        <hr></hr>
        <div className='small-card-container-lower'>
          <div className='small-card-container-lower-up'>
            <div className='card-text-desc'>
              {description}
            </div></div>

          <div className='small-card-container-lower-down'>
            <Button
              content={button_text}
              data-testid='refresh-btn'
              className='landing-page-button'
              onClick={onClick}
              size='small'
              textTransform={false}
            ></Button>
          </div>
        </div>


      </div>
    </>
  );
};

export const TabList: React.FC<TabListProps> = ({ role }) => {

  const tabConfig: TabConfig = {
    "insight.domain_focal":
      [
        {
          id: 1,
          icon: BuildWithSVG,
          text: 'Overview',
          description: 'Analyze the anomaly trends',
          button_text: 'Analyze',
          onClick: () => navigate(RouteConstants.OVERVIEW_ABSOLUTE_PATH), // navigation added to the come build us card for (data gpt) , i.e - come build with us.
        },
        {
          id: 2,
          icon: AnomalySVG,
          text: 'Anomalies',//overview changed to model review //model review changed to anomalies
          onClick: () => navigate(RouteConstants.ANOMALY_ABSOLUTE_PATH),//navigation of overview changed to model review.
          description: 'Review your list of anomalies here',
          button_text: 'Review',


        },
        {
          id: 3,
          icon: UnAssignedSVG,
          text: 'Unassigned Anomalies', //insights changes to kpi //KPI again changed to unassigned anomalies
          onClick: () => navigate(RouteConstants.ORPHAN_ABSOLUTE_PATH), //navigation changed from insight anomaly to KPI(metric tab) //again changed to unassigned anomalies
          description: 'Review / Update anomalies that are not properly assigned',
          button_text: 'Update',

        },
        // {
        //   id: 4,
        //   icon: SampleSVG,
        //   text: 'Sample', //added newly
        //   onClick: () => navigate(RouteConstants.SAMPLE_ABSOLUTE_PATH), //navigation changed from insight anomaly to Anomaly Page //// again navigation added to sample
        //   description: 'Generate a sample of anomalies',
        //   button_text: 'Sample',

        // }
      ],
    "insight.owner":
      [
        {
          id: 1,
          icon: AnomalySVG,
          text: 'Anomalies',//overview changed to model review //model review changed to anomalies
          onClick: () => navigate(RouteConstants.ANOMALY_ABSOLUTE_PATH),//navigation of overview changed to model review.
          description: 'Review your list of anomalies here',
          button_text: 'Review',

        }
      ],
    "insight.org_user":
      [
        {
          id: 1,
          icon: BuildWithSVG, text: 'Overview',
          onClick: () => navigate(RouteConstants.OVERVIEW_ABSOLUTE_PATH), // navigation added to the come build us card for (data gpt) , i.e - come build with us.
          description: 'Analyze the anomaly trends',
          button_text: 'Analyze',


        },
        {
          id: 2,
          icon: AnomalySVG,
          text: 'Anomalies',//overview changed to model review //model review changed to anomalies
          onClick: () => navigate(RouteConstants.ANOMALY_ABSOLUTE_PATH),//navigation of overview changed to model review.
          description: 'Review the list of anomalies for your org',
          button_text: 'Review',


        }
      ],
    "insight.power_user":
      [
        {
          id: 1,
          icon: BuildWithSVG, text: 'Overview',
          onClick: () => navigate(RouteConstants.OVERVIEW_ABSOLUTE_PATH), // navigation added to the come build us card for (data gpt) , i.e - come build with us.
          description: 'Analyze the anomaly trends',
          button_text: 'Analyze',


        },
        {
          id: 2,
          icon: AnomalySVG,
          text: 'Anomalies',//overview changed to model review //model review changed to anomalies
          onClick: () => navigate(RouteConstants.ANOMALY_ABSOLUTE_PATH),//navigation of overview changed to model review.
          description: 'Review your list of anomalies here',
          button_text: 'Review',



        },
        {
          id: 3,
          icon: SampleSVG,
          text: 'Sample', //added newly
          onClick: () => navigate(RouteConstants.SAMPLE_ABSOLUTE_PATH), //navigation changed from insight anomaly to Anomaly Page //// again navigation added to sample
          description: 'Generate a sample of anomalies',
          button_text: 'Sample',


        }
      ],
    "insight.functional_leadership":
      [
        {
          id: 1,
          icon: BuildWithSVG, text: 'Overview',
          onClick: () => navigate(RouteConstants.OVERVIEW_ABSOLUTE_PATH), // navigation added to the come build us card for (data gpt) , i.e - come build with us.
          description: 'Analyze the anomaly trends',
          button_text: 'Analyze',


        },
        {
          id: 2,
          icon: AnomalySVG,
          text: 'Anomalies',//overview changed to model review //model review changed to anomalies
          onClick: () => navigate(RouteConstants.ANOMALY_ABSOLUTE_PATH),//navigation of overview changed to model review.
          description: 'Review your list of anomalies here',
          button_text: 'Review',


        }
      ],
    "insight.viewer":
      [
        {
          id: 1,
          icon: AnomalySVG,
          text: 'Anomalies',//overview changed to model review //model review changed to anomalies
          onClick: () => navigate(RouteConstants.ANOMALY_ABSOLUTE_PATH),//navigation of overview changed to model review.
          description: 'Review your list of anomalies here',
          button_text: 'Review',


        }
      ],
    "model.power_user":
      [
        {
          id: 1,
          icon: ModelsSVG,
          text: 'Models',
          onClick: () => navigate(RouteConstants.CONTEXT),
          description: 'Review your list of models here',
          button_text: 'Review ',


        },
      ],
    "model.labeler":
      [
        {
          id: 1,
          icon: ModelsSVG,
          text: 'Models',
          onClick: () => navigate(RouteConstants.CONTEXT),
          description: 'List of models that require your training',
          button_text: 'Label',


        },
      ],
    "model.functional_leadership":
      [
        {
          id: 3,
          icon: BuildWithSVG,
          text: 'Model Review', //overview changed to model review
          onClick: () => navigate(RouteConstants.MODEL_REVIEW),
          description: 'Review model results',
          button_text: 'Review',


        },
        // {
        //   id: 4,
        //   icon: InsightsSVG,
        //   text: 'KPI',
        //   onClick: () => navigate(RouteConstants.MERTIC_DASHBOARD),
        //   description: 'Review model training reports',
        //   button_text: 'Review',
        // },
        // {
        //   id: 5,
        //   icon: ChatSVG,
        //   text: 'CAMS GPT',
        //   onClick: () => navigate(RouteConstants.CAMS_GPT),
        //   description: 'AI Model',
        //   button_text: 'CAMS GPT'
        // }
      ]
  };
  const tabs: Tab[] = tabConfig[role] || [];
  const navigate = useNavigate();
  return (
    <div className='left-container-down'>
      {tabs.map((data, key) => (
        <SmallCard key={data.id} {...data} />
      ))}
    </div>
  )
}


